import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import SiteHeaderConstants from '../constants/SiteHeaderConstants';
import AppConstants, { CHANGE_EVENT } from '../constants/AppConstants';

let _currentMenu = {};
let _modalFlag = false;
let _loadingFlag = false;
let _disableHeaderFlag = false;
let _sideBarFlag = false;
let _toBeSelectedMenu = {};
let _hideHeaderFlag = false;
let _manageCredFlag = false;
let _modalConfig = {};

class SiteHeaderStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }

  getCurrentMenu() {
    return _currentMenu;
  }

  getModalFlag() {
    return _modalFlag;
  }

  getLoadingFlag() {
    return _loadingFlag;
  }

  getDisableFlag() {
    return _disableHeaderFlag;
  }

  getToBeSelectedMenu() {
    return _toBeSelectedMenu;
  }

  setToBeSelectedMenu() {
    _toBeSelectedMenu = {};
  }

  getSideBarFlag() {
    return _sideBarFlag;
  }

  getHideHeaderFlag() {
    return _hideHeaderFlag;
  }

  getManageCredFlag() {
    return _manageCredFlag;
  }

  getModalConfig() {
    return _modalConfig;
  }

  resetStore() {
    _currentMenu = {};
    _modalFlag = false;
    _loadingFlag = false;
    _toBeSelectedMenu = {};
    _manageCredFlag = false;
  }

  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action;
    switch (actionType) {
      case SiteHeaderConstants.SET_MODAL_CONFIG:
        _modalConfig = actionData.data;
        _modalFlag = actionData.data.displayLeavePopup;
        this.emitChange();
        break;

      case SiteHeaderConstants.SET_CURRENT_MENU:
        _currentMenu = actionData.data;
        this.emitChange();
        break;

      case SiteHeaderConstants.SET_LOADING_FLAG:
        _loadingFlag = actionData.data;
        this.emitChange();
        break;

      case SiteHeaderConstants.SET_DISABLE_HEADER_FLAG:
        _disableHeaderFlag = actionData.data;
        this.emitChange();
        break;

      case SiteHeaderConstants.SET_SIDEBAR_FLAG:
        _sideBarFlag = actionData.data;
        this.emitChange();
        break;
      case SiteHeaderConstants.SET_TO_BE_SELECTED_NAV:
        _toBeSelectedMenu = actionData.data;
        this.emitChange();
        break;

      case SiteHeaderConstants.HIDE_HEADER_FLAG:
        _hideHeaderFlag = actionData.data;
        this.emitChange();
        break;
      case SiteHeaderConstants.MANAGE_CREDENTIALS_FLAG:
        _manageCredFlag = actionData.data;
        this.emitChange();
        break;
      case AppConstants.LOGOUT_USER:
        this.resetStore();
        this.emitChange();
        break;
      default: {
        break;
      }
    }
  }
}

export default new SiteHeaderStore();
